import * as RechartsPrimitive from "recharts"

const ChartAxis = {
  X: RechartsPrimitive.XAxis,
  Y: RechartsPrimitive.YAxis,
  // Bubble-size axis for scatter charts (maps a dataKey to marker area).
  Z: RechartsPrimitive.ZAxis,
}

export default ChartAxis
